import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import ViewOrderQRCode from "../../components/user/order/ViewOrderQRCode";
import UserAuth from "../../middleware/UserAuth";
import Layout from "../../components/web/Layout";
import Container from "../../components/ui/container/Container";
import { Helmet } from "react-helmet";
function OrderDetails() {
    const { id } = useParams();
    const [order, setOrder] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchOrder = async () => {
        try {
            setLoading(false);
            const { data } = await axios.get(
                `${process.env.REACT_APP_BASE_URL}api/user/v1/orderView/${id}`
            );

            if (data?.response && data.data) {
                setOrder(data.data);
            } else {
                setError("Order not found.");
            }
        } catch (err) {
            console.error("❌ Error fetching order:", err);
            setError("Failed to load order details.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (id) fetchOrder();
    }, [id]);

    // if (loading)
    //     return (
    //         <div className="flex items-center justify-center min-h-screen">
    //             <Loader2 className="animate-spin text-blue-600" size={40} />
    //         </div>
    //     );

    if (error)
        return (
            <div className="flex items-center justify-center min-h-screen text-red-600">
                {error}
            </div>
        );

    // if (!order)
    //     return (
    //         <div className="flex items-center justify-center min-h-screen text-gray-500">
    //             No order found.
    //         </div>
    //     );

    return (
        <Layout>
            <UserAuth>
                <Container className="my-6">
                    <Helmet>
                        <title>MOBO EAT | Products</title>
                    </Helmet>
                    <div className="min-h-screen flex justify-center items-center ">
                        <ViewOrderQRCode
                            order={order}
                            closeModal={() => window.history.back()}
                        />
                    </div>
                </Container>
            </UserAuth>
        </Layout>
    );
}

export default OrderDetails;
